document.addEventListener('DOMContentLoaded', ()=> {
    // Faq
    var faqTabBtns = document.querySelectorAll('.faq__categories-list-item-link.tab-button');
    var faqTabContents = document.querySelectorAll('.faq__details.tab-content');
    tabSettings(faqTabBtns, faqTabContents);
 
    
    function tabSettings(tabBtns, tabContents){
        tabBtns.forEach(element => {
            element.addEventListener('click', function(){
                var tabBtnId = this.dataset.tabButtonId;
                for (let i = 0; i < tabBtns.length; i++) {
                    tabBtns[i].classList.remove('is-active');
                }
                this.classList.add('is-active');

                for (let i = 0; i < tabContents.length; i++) {
                    var tabContentId = tabContents[i].dataset.tabContentId;
                    
                    if (tabBtnId == tabContentId) {
                        tabContents[i].classList.add('is-active');
                    } else {
                        tabContents[i].classList.remove('is-active');
                    }
                }
            })
        })
        tabBtns[0]?.click();
    }

})